import { render, staticRenderFns } from "./ModalElectronicGame.vue?vue&type=template&id=4383664b&"
import script from "./ModalElectronicGame.vue?vue&type=script&lang=js&"
export * from "./ModalElectronicGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports